<template>
  <component
    :is="getComponent"
    :product="product"
    :is-outlet-product="isOutletProduct"
    @selected="selected"
    @selected-options="onSelectedOptions"
  >
    <template #oos="slotProps">
      <LazyUiDialog
        v-if="!['GroupedProduct', 'GiftCardProduct'].includes(props.product.__typename)"
        name="product-oos-dialog"
        class="add-to-cart__oos-dialog"
        dialog-type="modal"
        @vue:updated="() => syncOosFromSlot(slotProps)"
      >
        <template #dialogHeader>
          {{ $t('Sold out') }}
        </template>
        <slot
          name="oos"
          v-bind="slotProps"
        />
      </LazyUiDialog>
    </template>
  </component>
</template>

<script lang="ts" setup>
import type {
  MagentoCartItemInput,
  MagentoConfigurableProduct,
  MagentoConfigurableProductCartItemInput,
  MagentoConfigurableProductOptionsValue,
  MagentoGiftCardProduct,
  MagentoGroupedProduct,
  MagentoProduct,
} from '~layers/app/types/magento'

import {
  ProductConfigurable,
  ProductGrouped,
  ProductGiftCard,
  ProductSimple,
} from '#components'

export interface Props {
  product: MagentoProduct | MagentoConfigurableProduct | MagentoGroupedProduct | MagentoGiftCardProduct
  isOutletProduct?: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'selected': [item: Record<string, MagentoCartItemInput | MagentoConfigurableProductCartItemInput>]
  'selected-options': [options: Record<string, MagentoConfigurableProductOptionsValue>]
}>()

const { open: openDialog, settings } = useUiDialog('product-oos-dialog')

const syncOosFromSlot = (slotProps: unknown) => {
  if (props.isOutletProduct) return
  if (!Array.isArray(slotProps?.oos)) return
  if (slotProps?.oos[0] && slotProps?.selectedOptions) {
    openOosDialog()
  }
}

const openOosDialog = () => {
  if (settings.value.isOpen) return
  openDialog()
}

const getComponent = computed(() => {
  switch (props.product.__typename) {
    case 'ConfigurableProduct': return ProductConfigurable
    case 'GroupedProduct': return ProductGrouped
    case 'GiftCardProduct': return ProductGiftCard
    default: return ProductSimple
  }
})

const selected = (item: Record<string, MagentoCartItemInput>) => {
  emit('selected', item)
}

const onSelectedOptions = (options: Record<string, MagentoConfigurableProductOptionsValue>) => {
  emit('selected-options', options)
}
</script>
